__turbopack_context__.v({
  "button": "tkEe-q_button",
  "embeddedFormWrapper": "tkEe-q_embeddedFormWrapper",
  "form": "tkEe-q_form",
  "headline": "tkEe-q_headline",
  "inputGrid": "tkEe-q_inputGrid",
  "subtitleCopy": "tkEe-q_subtitleCopy",
  "titleWrapper": "tkEe-q_titleWrapper",
});
